export const MIN_IMPACTOS = 9;
export const MAX_IMPACTOS = 16;
export const MIN_VALIDOS = 5;
export const REFERENCIA_CORRECAO_ANGULAR_R =
  "Screening Eagle/Proceq Original Schmidt OS8000 tipo N";
export const FONTE_CURVAS_REFERENCIA = "https://www.screeningeagle.com/en/academy/faq/what-are-the-formulae-used-in-the-compressive-strength-correlation-curves-%20rebound-hammers";
// Pares [R, MPa] aproximados, digitalizados da imagem fornecida pelo solicitante.
// São curvas direcionais: não aplicar antes a fórmula de correção angular.
export const PONTOS_ABACO_N_NR = {
  "-90": [[20,15.5],[25,22.3],[30,30.6],[35,39],[40,48.3],[45,58.2],[50,68.3],[50.9,70]],
  "0": [[20,10],[25,16.9],[30,24.9],[35,33.4],[40,42.6],[45,52.1],[50,62.2],[53.7,70]],
  "90": [[26.1,10],[30,16.6],[35,25.1],[40,34.4],[45,43.9],[50,54.2],[53,60.2],[54,62.3],[55,64]],
};

export function calcularResistenciaAbaco(indice, angulo) {
  const pontos = PONTOS_ABACO_N_NR[String(angulo)];
  if (!pontos || indice === null || !Number.isFinite(indice) || indice < pontos[0][0] || indice > pontos[pontos.length - 1][0]) return null;
  for (let i = 1; i < pontos.length; i += 1) {
    const [x0,y0] = pontos[i - 1];
    const [x1,y1] = pontos[i];
    if (indice <= x1) return y0 + (indice - x0) * (y1 - y0) / (x1 - x0);
  }
  return null;
}

export function obterCurvaCorrelacao() {
  return {
    ativa: true, origem: "abaco_n_nr", tipo: "abaco",
    referencia: "Ábaco fornecido pelo solicitante — Concrete Hammer N/NR (índice R)",
    formula: "Interpolação linear entre pontos digitalizados da curva correspondente à direção do impacto",
    corpoReferencia: "Cubos de 150 × 150 × 150 mm; concreto de 14 a 56 dias; N/mm² = MPa",
    fonte: "Imagem do ábaco fornecida pelo solicitante; leitura gráfica aproximada",
    indiceMinimo: 20, indiceMaximo: 55,
  };
}

export function numero(valor) {
  if (valor === null || valor === undefined || String(valor).trim() === "") return null;
  const convertido = Number(String(valor).replace(",", "."));
  return Number.isFinite(convertido) ? convertido : null;
}

export function criarArea(index = 0) {
  return {
    id: `area-${Date.now()}-${index}`,
    identificacao: `ÁREA ${String(index + 1).padStart(2, "0")}`,
    localizacao: "",
    dataConcretagem: "",
    notaFiscal: "",
    idadeDias: "",
    resistenciaReferenciaIdade: "",
    resistenciaReferenciaMpa: "",
    posicao: "0° (horizontal)",
    coeficientePosicao: "1",
    leituras: Array(MAX_IMPACTOS).fill(""),
    observacoes: "",
  };
}

function media(valores) {
  if (!valores.length) return null;
  return valores.reduce((soma, valor) => soma + valor, 0) / valores.length;
}

function desvioPadraoAmostral(valores) {
  if (valores.length < 2) return null;
  const valorMedio = media(valores);
  const soma = valores.reduce((total, valor) => total + (valor - valorMedio) ** 2, 0);
  return Math.sqrt(soma / (valores.length - 1));
}

function anguloImpacto(area = {}) {
  if (area.posicao === "+90° (vertical para cima)") return 90;
  if (area.posicao === "-90° (vertical para baixo)") return -90;
  if (area.posicao === "Outra") return numero(area.anguloImpacto);
  return 0;
}

export function calcularCorrecaoAngularR(indice, anguloGraus) {
  const r = numero(indice);
  const angulo = numero(anguloGraus);
  if (r === null || angulo === null || angulo < -90 || angulo > 90) return null;
  const { a0, a1 } = angulo >= 0
    ? { a0: 7.1, a1: 0.08 }
    : { a0: 4.3, a1: 0.043 };
  const correcao = (-a0 + r * a1) * Math.sin((angulo * Math.PI) / 180);
  return {
    angulo,
    correcao,
    indiceCorrigido: r + correcao,
  };
}

export function calcularVerificacaoBigorna(valores = [], nominal, tolerancia = 2) {
  const referencia = numero(nominal);
  const leituras = (Array.isArray(valores) ? valores : []).map(numero);
  const informadas = leituras.filter((valor) => valor !== null);
  const completa = informadas.length >= 10 && informadas.every((valor) => valor > 0);
  const referenciaValida = referencia !== null && referencia > 0;
  const soma = informadas.reduce((total, valor) => total + valor, 0);
  const mediaBigorna = media(informadas);
  const resultados = leituras.map((valor) => ({
    valor,
    conforme: valor === null || !referenciaValida ? null : valor > 0 && Math.abs(valor - referencia) <= tolerancia,
  }));
  const reprovada = referenciaValida && resultados.some((item) => item.conforme === false);
  const conforme = completa && referenciaValida && !reprovada;
  return {
    resultados, quantidade: informadas.length, referencia, tolerancia, soma,
    media: mediaBigorna,
    k: conforme && mediaBigorna > 0 ? referencia / mediaBigorna : null,
    conforme,
    situacao: reprovada ? "REPROVADO" : conforme ? "CONFORME" : "PENDENTE",
    motivo: !referenciaValida ? "Informe o índice nominal da bigorna (maior que zero)."
      : reprovada ? `Leitura fora de ±${tolerancia} pontos do índice nominal da bigorna.`
      : !completa ? "Informe pelo menos 10 leituras positivas na bigorna."
      : "",
  };
}

export function calcularValidacaoEnsaio(registro = {}, areas = registro.areas || []) {
  const nominal = registro.equipamento?.indiceNominalBigorna;
  const antes = calcularVerificacaoBigorna(registro.verificacaoBigornaAntes, nominal, 2);
  const depois = calcularVerificacaoBigorna(registro.verificacaoBigornaDepois, nominal, 4);
  const totalImpactos = areas.reduce((total, area) => total + (area.leituras || []).filter((valor) => numero(valor) !== null).length, 0);
  const motivo = !antes.conforme ? `Bigorna antes dos trabalhos: ${antes.motivo}`
    : !depois.conforme ? `Bigorna após os trabalhos: ${depois.motivo}`
    : !registro.dataVerificacaoBigorna ? "Informe a data de verificação na bigorna."
    : totalImpactos > 300 ? "Este registro ultrapassa 300 impactos. Separe os ensaios em ciclos com suas próprias verificações na bigorna."
    : "";
  return { antes, depois, totalImpactos, valido: !motivo, motivo, k: !motivo ? depois.k : null };
}

export function calcularArea(area = {}, curva = {}, metodoIndice = "R", validacao = null) {
  curva = obterCurvaCorrelacao(curva, metodoIndice);
  const leiturasInformadas = (Array.isArray(area.leituras) ? area.leituras : [])
    .map(numero)
    .filter((valor) => valor !== null);
  const mediaInicial = media(leiturasInformadas);
  const valoresValidos = mediaInicial === null
    ? []
    : leiturasInformadas.filter(
        (valor) => valor >= mediaInicial * 0.9 && valor <= mediaInicial * 1.1
      );
  const mediaFinal = media(valoresValidos);
  const atendeMediaFinal = mediaFinal !== null
    ? valoresValidos.every((valor) => valor >= mediaFinal * 0.9 && valor <= mediaFinal * 1.1)
    : false;
  const quantidadeAdequada =
    leiturasInformadas.length >= MIN_IMPACTOS && leiturasInformadas.length <= MAX_IMPACTOS;
  const valido = quantidadeAdequada && valoresValidos.length >= MIN_VALIDOS && atendeMediaFinal;
  const desvioPadrao = desvioPadraoAmostral(valoresValidos);
  const coeficienteVariacao =
    mediaFinal && desvioPadrao !== null ? (desvioPadrao / mediaFinal) * 100 : null;
  const metodo = String(metodoIndice || "R").toUpperCase();
  const usaAbaco = curva.origem === "abaco_n_nr";
  const angulo = metodo === "Q" ? 0 : anguloImpacto(area);
  const correcaoAngular = metodo === "Q"
    ? mediaFinal === null
      ? null
      : { angulo: 0, correcao: 0, indiceCorrigido: mediaFinal }
    : usaAbaco && mediaFinal !== null
    ? { angulo, correcao: 0, indiceCorrigido: mediaFinal }
    : calcularCorrecaoAngularR(mediaFinal, angulo);
  const correcaoPosicaoValida = metodo === "Q" || correcaoAngular !== null;
  const indiceCorrigidoPosicao = correcaoAngular?.indiceCorrigido ?? null;
  const indiceEfetivo = indiceCorrigidoPosicao === null || (validacao && !validacao.valido)
    ? null
    : indiceCorrigidoPosicao * (validacao?.k ?? 1);
  const curvaDocumentada = Boolean(String(curva.referencia || "").trim());
  const areaValida = valido && correcaoPosicaoValida && (!validacao || validacao.valido);

  let resistenciaCorrelativa = null;
  const a = numero(curva.coeficienteA);
  const b = numero(curva.coeficienteB);
  const c = numero(curva.coeficienteC);
  const coeficientesPreenchidos =
    usaAbaco || (a !== null && b !== null && (["linear", "exponencial"].includes(curva.tipo) || c !== null));
  const pontosAbaco = usaAbaco ? PONTOS_ABACO_N_NR[String(angulo)] : null;
  const minimoAbaco = pontosAbaco?.[0]?.[0];
  const maximoAbaco = pontosAbaco?.[pontosAbaco.length - 1]?.[0];
  const minimo = usaAbaco ? minimoAbaco ?? null : numero(curva.indiceMinimo);
  const maximo = usaAbaco ? maximoAbaco ?? null : numero(curva.indiceMaximo);
  const dentroDaFaixa = indiceEfetivo !== null && (minimo === null || indiceEfetivo >= minimo) && (maximo === null || indiceEfetivo <= maximo);
  const resistenciaCorrelativaAcima70 = Boolean(curva.ativa && areaValida && curvaDocumentada && usaAbaco && metodo === "R" &&
    (angulo === 0 || angulo === -90) && indiceEfetivo > 55 && pontosAbaco?.[pontosAbaco.length - 1]?.[1] === 70);
  let motivoResistencia = !curva.ativa ? "Cálculo de resistência desativado."
    : !areaValida ? "Área ou verificação na bigorna não validada."
    : usaAbaco && metodo !== "R" ? "O ábaco N/NR fornecido utiliza índice R e não se aplica ao método Q."
    : usaAbaco && !pontosAbaco ? "O ábaco digitalizado contempla somente 0°, +90° e -90°."
    : !curvaDocumentada ? "Informe a referência da curva."
    : !coeficientesPreenchidos ? "Preencha os coeficientes da curva."
    : !dentroDaFaixa && !resistenciaCorrelativaAcima70 ? `Índice efetivo fora da faixa da curva (${minimo ?? "-"} a ${maximo ?? "-"}). Sem extrapolação.`
    : "";
  if (!motivoResistencia && !resistenciaCorrelativaAcima70) {
    resistenciaCorrelativa =
      usaAbaco ? calcularResistenciaAbaco(indiceEfetivo, angulo)
      : curva.tipo === "linear"
        ? a * indiceEfetivo + b
        : curva.tipo === "exponencial"
        ? a * Math.exp(b * indiceEfetivo)
        : a * indiceEfetivo ** 2 + b * indiceEfetivo + c;
    if (!Number.isFinite(resistenciaCorrelativa) || resistenciaCorrelativa <= 0) {
      resistenciaCorrelativa = null;
      motivoResistencia = "A curva não produziu uma resistência positiva finita.";
    }
  }

  const referenciaProjeto = numero(area.resistenciaReferenciaMpa);
  const resistenciaProjetoMpa = referenciaProjeto !== null && referenciaProjeto > 0 ? referenciaProjeto : null;
  const diferencaProjetoMpa = resistenciaProjetoMpa !== null && resistenciaCorrelativa !== null
    ? resistenciaCorrelativa - resistenciaProjetoMpa : null;
  const diferencaProjetoPercentual = diferencaProjetoMpa === null ? null : diferencaProjetoMpa / resistenciaProjetoMpa * 100;
  const comparacaoProjeto = resistenciaProjetoMpa === null ? "Informe a resistência de projeto em MPa."
    : resistenciaCorrelativaAcima70 ? resistenciaProjetoMpa <= 70
      ? "Indicação > 70 MPa, acima da referência de projeto; diferença exata não determinada."
      : "Indicação > 70 MPa; insuficiente para comparar com a referência de projeto acima de 70 MPa."
    : resistenciaCorrelativa === null ? `Comparação pendente: ${motivoResistencia}`
    : diferencaProjetoMpa < 0 ? "Estimativa abaixo da resistência de projeto."
    : diferencaProjetoMpa > 0 ? "Estimativa acima da resistência de projeto."
    : "Estimativa igual à resistência de projeto.";

  return {
    ...area,
    leiturasInformadas,
    mediaInicial,
    valoresValidos,
    quantidadeValidos: valoresValidos.length,
    mediaFinal,
    metodoIndice: metodo,
    anguloImpacto: angulo,
    correcaoPosicao: correcaoAngular?.correcao ?? null,
    indiceCorrigidoPosicao,
    referenciaCorrecaoPosicao:
      metodo === "Q" ? "Não aplicável ao método Q" : usaAbaco ? "Direção considerada na curva do ábaco; sem correção angular adicional" : REFERENCIA_CORRECAO_ANGULAR_R,
    correcaoAngularNoAbaco: usaAbaco && metodo === "R",
    indiceEfetivo,
    coeficienteBigorna: validacao?.k ?? null,
    desvioPadrao,
    coeficienteVariacao,
    resistenciaCorrelativa,
    resistenciaCorrelativaAcima70,
    resistenciaProjetoMpa,
    diferencaProjetoMpa,
    diferencaProjetoPercentual,
    comparacaoProjeto,
    motivoResistencia,
    referenciaResistencia: curva.referencia || "",
    resistenciaReferenciaFabricante: curva.origem === "referencia" || usaAbaco,
    resistenciaPorAbaco: usaAbaco,
    valido: areaValida,
    motivoInvalido: validacao && !validacao.valido
      ? validacao.motivo
      : !quantidadeAdequada
      ? `Informe de ${MIN_IMPACTOS} a ${MAX_IMPACTOS} impactos.`
      : valoresValidos.length < MIN_VALIDOS
      ? `Restaram menos de ${MIN_VALIDOS} valores válidos.`
      : !atendeMediaFinal
      ? "Há leitura válida fora de ±10% da média final."
      : !correcaoPosicaoValida
      ? "Informe um ângulo entre -90° e +90°."
      : "",
  };
}

export function formatarNumero(valor, casas = 1) {
  const convertido = numero(valor);
  return convertido === null
    ? "-"
    : convertido.toLocaleString("pt-BR", {
        minimumFractionDigits: casas,
        maximumFractionDigits: casas,
      });
}

export function formatarResistenciaCorrelativa(area = {}) {
  return area.resistenciaCorrelativaAcima70 ? "> 70" : formatarNumero(area.resistenciaCorrelativa, 1);
}
